import { Phone } from '~components/AllianceCallService/AllianceCallService';
import Section from '~components/_layout/Section';
import BrowseBadge from '~images/inline/browse.inline.svg';
import Checkmark from '~images/inline/checkmark.inline.svg';
import CodeBadge from '~images/inline/code.inline.svg';
import EnrollBadge from '~images/inline/enroll.inline.svg';

const HowItWorksRedesign = () => {
    const steps = [
        {
            title: 'Enter PlanMatch Code',
            content: 'Enter your PlanMatch code, ZIP Code and birth year and select "See Plans."',
            image: <CodeBadge />,
        },
        {
            title: 'Browse Results',
            content:
                'Compare benefits, costs and coverage and take advantage of our powerful, online comparison tools.',
            image: <BrowseBadge />,
        },
        {
            title: 'Enroll',
            content: (
                <>
                    Complete your application online or over the phone with a licensed insurance
                    agent at <Phone islink={true} /> TTY 711.
                </>
            ),
            image: <EnrollBadge />,
        },
    ];

    const howItWorksList = [
        'Safe, secure browsing',
        'Automatically generated and totally unique to you',
        'Completely anonymous',
        'Contains no personal information',
    ];

    return (
        <Section extraClasses="py-6 px-4 md:py-10 md:px-6 text-black bg-gray-lightest">
            <h2 className="text-center font-bold text-xl md:text-2xl lg:text-3xl mb-4 md:mb-6">
                How it works
            </h2>
            <div className="max-w-screen-xl mx-auto grid gap-4 grid-cols-1 md:gap-6 md:grid-cols-3 mb-6 lg:mb-10">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className="bg-white rounded-lg shadow-xl flex md:flex-col p-2 md:p-4 border border-gray-lighter"
                    >
                        <div className="w-10 h-10 mr-2 md:mr-0 md:mb-2">{step.image}</div>
                        <div>
                            <h3 className="font-bold text-base md:text-xl mb-2">
                                {index + 1}. {step.title}
                            </h3>
                            <p className="text-base">{step.content}</p>
                        </div>
                    </div>
                ))}
            </div>
            <h3 className="font-semibold text-center text-lg md:text-xl lg:text-2xl mb-4">
                Your PlanMatch code is your key to safe shopping
            </h3>
            <ul className="max-w-[1100px] mx-auto grid gap-2 grid-cols-1 md:gap-6 md:grid-cols-4">
                {howItWorksList.map((item, index) => (
                    <li
                        key={index}
                        className="flex md:justify-center items-center text-base md:text-lg"
                    >
                        <div className="w-4 h-[13px] mr-3">
                            <Checkmark />
                        </div>
                        <span>{item}</span>
                    </li>
                ))}
            </ul>
        </Section>
    );
};

export default HowItWorksRedesign;
